<div class="registration-v2-layout">
  @if (isRegistrationComplete()) {
    <glxy-alert type="success" class="step-info-panel">
      {{ 'SMS_REGISTRATION.V2.STATUS.APPROVED' | translate }}
    </glxy-alert>
  } @else if (formLocked()) {
    <glxy-alert type="info" class="step-info-panel">
      {{ 'SMS_REGISTRATION.V2.STATUS.REVIEWING' | translate }}
      @if (submittedDate()) {
        <br /><strong>{{ 'SMS_REGISTRATION.V2.REVIEW.SUBMITTED_DATE' | translate }}:</strong>
        {{ submittedDate() | date: 'mediumDate' }}
      }
    </glxy-alert>
  }
  <form [formGroup]="smsForm">
    <mat-stepper
      [selectedIndex]="currentStep()"
      (selectionChange)="onStepChange($event)"
      [linear]="false"
      labelPosition="bottom"
    >
      <mat-step [label]="'SMS_REGISTRATION.V2.STEPS.BRAND_INFO' | translate">
        @if (isDataErrorState()) {
          <glxy-alert type="error" class="step-info-panel">
            {{ 'SMS_REGISTRATION.V2.STATUS.BRAND_REJECTED' | translate }}
          </glxy-alert>
        } @else if (isBrandApproved()) {
          <glxy-alert type="success" class="step-info-panel">
            {{ 'SMS_REGISTRATION.V2.STATUS.BRAND_APPROVED' | translate }}
          </glxy-alert>
        } @else if (!formLocked()) {
          <glxy-alert type="info" class="step-info-panel">
            {{ 'SMS_REGISTRATION.V2.HELP.BRAND_BODY' | translate }}
          </glxy-alert>
        }

        <div class="step-header">
          <h2>{{ 'SMS_REGISTRATION.V2.BRAND.TITLE' | translate }}</h2>
        </div>

        <div formGroupName="brand">
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.LEGAL_NAME_LABEL' | translate }}</glxy-label>
            <input formControlName="businessName" matInput />
            <glxy-hint>{{ 'SMS_REGISTRATION.V2.BRAND.LEGAL_NAME_HINT' | translate }}</glxy-hint>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.CATEGORY_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="businessCategory">
              @for (cat of BusinessCategories; track cat) {
                <mat-option [value]="cat">{{ cat | businessCategoryToLabel }}</mat-option>
              }
            </mat-select>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.TYPE_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="businessType">
              @for (type of BusinessTypes; track type) {
                <mat-option [value]="type">{{ type }}</mat-option>
              }
            </mat-select>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.REGION_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="regionOfOperation">
              @for (region of Regions; track region) {
                <mat-option [value]="region">{{ region | regionToLabel }}</mat-option>
              }
            </mat-select>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.EIN_LABEL' | translate }}</glxy-label>
            <input formControlName="businessRegistrationNumber" matInput />
            <glxy-hint>{{ 'SMS_REGISTRATION.V2.BRAND.EIN_HINT' | translate }}</glxy-hint>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.ADDRESS_LABEL' | translate }}</glxy-label>
            <input formControlName="address" matInput />
          </glxy-form-field>

          <glxy-form-field>
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.ADDRESS_LINE_2_LABEL' | translate }}</glxy-label>
            <input formControlName="additionalAddressLine" matInput />
          </glxy-form-field>

          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.STATE_LABEL' | translate }}</glxy-label>
              <input formControlName="state" matInput />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.CITY_LABEL' | translate }}</glxy-label>
              <input formControlName="city" matInput />
            </glxy-form-field>
          </glxy-form-row>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.ZIP_CODE_LABEL' | translate }}</glxy-label>
            <input formControlName="zipCode" matInput />
            <glxy-hint>{{ 'SMS_REGISTRATION.V2.BRAND.ZIP_CODE_HINT' | translate }}</glxy-hint>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.WEBSITE_LABEL' | translate }}</glxy-label>
            <input formControlName="website" matInput type="url" />
          </glxy-form-field>

          <h3 class="section-subtitle">{{ 'SMS_REGISTRATION.V2.BRAND.AUTHORIZED_REP_TITLE' | translate }}</h3>

          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.FIRST_NAME_LABEL' | translate }}</glxy-label>
              <input formControlName="firstName" matInput />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.LAST_NAME_LABEL' | translate }}</glxy-label>
              <input formControlName="lastName" matInput />
            </glxy-form-field>
          </glxy-form-row>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.JOB_POSITION_LABEL' | translate }}</glxy-label>
            <mat-select formControlName="jobPosition">
              @for (pos of JobPositions; track pos) {
                <mat-option [value]="pos">{{ pos }}</mat-option>
              }
            </mat-select>
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.BUSINESS_TITLE_LABEL' | translate }}</glxy-label>
            <input formControlName="businessTitle" matInput />
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.BRAND.EMAIL_LABEL' | translate }}</glxy-label>
            <input formControlName="email" matInput type="email" />
          </glxy-form-field>

          <sms-phone-input
            [formGroup]="phoneInputFormGroup"
            [label]="'SMS_REGISTRATION.V2.BRAND.PHONE_LABEL' | translate"
            [required]="true"
          ></sms-phone-input>
        </div>
      </mat-step>

      <mat-step [label]="'SMS_REGISTRATION.V2.STEPS.CAMPAIGN' | translate">
        @if (isCampaignErrorState()) {
          <glxy-alert type="error" class="step-info-panel">
            @if (campaignErrorItems().length) {
              {{ 'SMS_REGISTRATION.V2.STATUS.CAMPAIGN_REJECTED_WITH_REASONS' | translate }}
              <ul class="campaign-rejection-reasons">
                @for (error of campaignErrorItems(); track $index) {
                  <li>
                    @if (error.fieldsLabel) {
                      <span class="campaign-rejection-field">{{ error.fieldsLabel }}:</span>
                    }
                    {{ error.message }}
                  </li>
                }
              </ul>
            } @else {
              {{ 'SMS_REGISTRATION.V2.STATUS.CAMPAIGN_REJECTED' | translate }}
            }
          </glxy-alert>
        } @else if (!formLocked()) {
          <glxy-alert type="info" class="step-info-panel">
            {{ 'SMS_REGISTRATION.V2.HELP.CAMPAIGN_BODY' | translate }}
          </glxy-alert>
        }

        <glxy-alert type="info" class="step-info-panel">
          {{ 'SMS_REGISTRATION.V2.CAMPAIGN.EXAMPLE_SITE_INTRO' | translate }}
          <a href="https://a2p-example.businessapp.io/" target="_blank" rel="noopener noreferrer">{{
            'SMS_REGISTRATION.V2.CAMPAIGN.EXAMPLE_SITE_LINK' | translate
          }}</a
          >.
        </glxy-alert>

        <div class="step-header">
          <h2>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TITLE' | translate }}</h2>
        </div>

        <div formGroupName="campaign">
          <h3 class="section-subtitle">{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEBCHAT_TITLE' | translate }}</h3>
          <glxy-form-field bottomSpacing="small">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEBCHAT_QUESTION' | translate }}</glxy-label>
            <mat-radio-group formControlName="hasWebchatWidget">
              <mat-radio-button [value]="true">{{ 'SMS_REGISTRATION.V2.REVIEW.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false">{{ 'SMS_REGISTRATION.V2.REVIEW.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </glxy-form-field>

          @if (campaignForm.controls.hasWebchatWidget.value) {
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEBCHAT_URL_LABEL' | translate }}</glxy-label>
              <input formControlName="webchatWidgetUrl" matInput type="url" />
              <glxy-hint>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEBCHAT_URL_HINT' | translate }}</glxy-hint>
            </glxy-form-field>
          }

          <h3 class="section-subtitle">{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_TITLE' | translate }}</h3>
          <glxy-form-field bottomSpacing="small">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_QUESTION' | translate }}</glxy-label>
            <mat-radio-group formControlName="hasWebForm">
              <mat-radio-button [value]="true">{{ 'SMS_REGISTRATION.V2.REVIEW.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false">{{ 'SMS_REGISTRATION.V2.REVIEW.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </glxy-form-field>

          @if (campaignForm.controls.hasWebForm.value) {
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_URL_LABEL' | translate }}</glxy-label>
              <input formControlName="webFormUrl" matInput type="url" />
              <glxy-hint>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_URL_HINT' | translate }}</glxy-hint>
            </glxy-form-field>
            <div class="policy-requirements">
              <p>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_INTRO' | translate }}</p>
              <ul>
                <li>
                  <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_TRANSACTIONAL' | translate }}</strong>
                  {{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_TRANSACTIONAL_TEXT' | translate }}
                </li>
                <li>
                  <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_MARKETING' | translate }}</strong>
                  {{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_MARKETING_TEXT' | translate }}
                </li>
                <li>
                  <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_DISCLOSURE' | translate }}</strong>
                  {{ 'SMS_REGISTRATION.V2.CAMPAIGN.WEB_FORM_HELP_DISCLOSURE_TEXT' | translate }}
                </li>
              </ul>
            </div>
          }

          <h3 class="section-subtitle">{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_LABEL' | translate }}</h3>
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_FIELD_LABEL' | translate }}</glxy-label>
            <input formControlName="privacyPolicyUrl" matInput type="url" />
            <glxy-hint>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HINT' | translate }}</glxy-hint>
            @if (
              campaignForm.controls.privacyPolicyUrl.hasError('pattern') &&
              campaignForm.controls.privacyPolicyUrl.touched
            ) {
              <glxy-error>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.HTTPS_URL_ERROR' | translate }}</glxy-error>
            }
          </glxy-form-field>
          <div class="policy-requirements">
            <ul>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_CONSENT_SHARING' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_CONSENT_SHARING_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_OPT_IN' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_OPT_IN_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_OPT_OUT' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_OPT_OUT_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_HELP' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_HELP_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_RATES' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.PRIVACY_POLICY_HELP_RATES_TEXT' | translate }}
              </li>
            </ul>
          </div>

          <h3 class="section-subtitle">{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_LABEL' | translate }}</h3>
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_FIELD_LABEL' | translate }}</glxy-label>
            <input formControlName="termsAndConditionsUrl" matInput type="url" />
            <glxy-hint>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HINT' | translate }}</glxy-hint>
            @if (
              campaignForm.controls.termsAndConditionsUrl.hasError('pattern') &&
              campaignForm.controls.termsAndConditionsUrl.touched
            ) {
              <glxy-error>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.HTTPS_URL_ERROR' | translate }}</glxy-error>
            }
          </glxy-form-field>
          <div class="policy-requirements">
            <ul>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_PROGRAM' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_PROGRAM_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_DISCLOSURES' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_DISCLOSURES_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_OPT_OUT' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_OPT_OUT_TEXT' | translate }}
              </li>
              <li>
                <strong>{{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_CONTACT' | translate }}</strong>
                {{ 'SMS_REGISTRATION.V2.CAMPAIGN.TERMS_HELP_CONTACT_TEXT' | translate }}
              </li>
            </ul>
          </div>
        </div>
      </mat-step>

      <mat-step [label]="'SMS_REGISTRATION.V2.STEPS.REVIEW' | translate">
        <div class="step-header">
          <h2>
            {{
              (formLocked() ? 'SMS_REGISTRATION.V2.REVIEW.TITLE_SUBMITTED' : 'SMS_REGISTRATION.V2.REVIEW.TITLE')
                | translate
            }}
          </h2>
        </div>

        @if (!formLocked()) {
          <glxy-alert type="info" class="step-info-panel">
            {{ 'SMS_REGISTRATION.V2.HELP.REVIEW_BODY' | translate }}
          </glxy-alert>

          <sms-feature-flag-gate [featureFlags]="['a2p_analysis_assistant']">
            <sms-a2p-analysis enabled [form]="smsForm"></sms-a2p-analysis>
          </sms-feature-flag-gate>
        }

        <mat-card class="summary-card">
          <mat-card-header>
            <mat-card-title>{{ 'SMS_REGISTRATION.V2.REVIEW.BRAND_CARD_TITLE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <dl class="summary-list">
              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.BUSINESS_NAME' | translate }}</dt>
              <dd>{{ brandSummary.businessName || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.BUSINESS_CATEGORY' | translate }}</dt>
              <dd>{{ brandSummary.businessCategory || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.BUSINESS_TYPE' | translate }}</dt>
              <dd>{{ brandSummary.businessType || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.REGION' | translate }}</dt>
              <dd>{{ brandSummary.regionOfOperation || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.EIN' | translate }}</dt>
              <dd>{{ brandSummary.businessRegistrationNumber || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.ADDRESS' | translate }}</dt>
              <dd>
                {{ brandSummary.address || '—' }}
                @if (brandSummary.additionalAddressLine) {
                  , {{ brandSummary.additionalAddressLine }}
                }
              </dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.CITY_STATE_ZIP' | translate }}</dt>
              <dd>
                {{ brandSummary.city || '—' }}, {{ brandSummary.state || '—' }}
                {{ brandSummary.zipCode || '' }}
              </dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.WEBSITE' | translate }}</dt>
              <dd>{{ brandSummary.website || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.AUTHORIZED_REP' | translate }}</dt>
              <dd>{{ brandSummary.firstName }} {{ brandSummary.lastName }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.TITLE_POSITION' | translate }}</dt>
              <dd>{{ brandSummary.businessTitle || '—' }} ({{ brandSummary.jobPosition || '—' }})</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.EMAIL' | translate }}</dt>
              <dd>{{ brandSummary.email || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.PHONE' | translate }}</dt>
              <dd>{{ brandSummary.phoneNumber || '—' }}</dd>
            </dl>
          </mat-card-content>
        </mat-card>

        <mat-card class="summary-card">
          <mat-card-header>
            <mat-card-title>{{ 'SMS_REGISTRATION.V2.REVIEW.CAMPAIGN_CARD_TITLE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <dl class="summary-list">
              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.WEBCHAT_WIDGET' | translate }}</dt>
              <dd>
                {{
                  campaignSummary.hasWebchatWidget
                    ? ('SMS_REGISTRATION.V2.REVIEW.YES' | translate)
                    : ('SMS_REGISTRATION.V2.REVIEW.NO' | translate)
                }}
              </dd>

              @if (campaignSummary.hasWebchatWidget) {
                <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.WEBCHAT_URL' | translate }}</dt>
                <dd>{{ campaignSummary.webchatWidgetUrl || '—' }}</dd>
              }

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.WEB_FORM' | translate }}</dt>
              <dd>
                {{
                  campaignSummary.hasWebForm
                    ? ('SMS_REGISTRATION.V2.REVIEW.YES' | translate)
                    : ('SMS_REGISTRATION.V2.REVIEW.NO' | translate)
                }}
              </dd>

              @if (campaignSummary.hasWebForm) {
                <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.WEB_FORM_URL' | translate }}</dt>
                <dd>{{ campaignSummary.webFormUrl || '—' }}</dd>
              }

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.PRIVACY_POLICY' | translate }}</dt>
              <dd>{{ campaignSummary.privacyPolicyUrl || '—' }}</dd>

              <dt>{{ 'SMS_REGISTRATION.V2.REVIEW.TERMS_OF_SERVICE' | translate }}</dt>
              <dd>{{ campaignSummary.termsAndConditionsUrl || '—' }}</dd>
            </dl>
          </mat-card-content>
        </mat-card>
      </mat-step>
    </mat-stepper>
  </form>
</div>

@if (!formLocked()) {
  <glxy-sticky-footer>
    @if (!isFirstStep()) {
      <button mat-stroked-button (click)="prevStep()">{{ 'SMS_REGISTRATION.FORM.ACTIONS.BACK' | translate }}</button>
    }

    @if (isA2pSubmitRestricted()) {
      <button mat-flat-button color="primary" (click)="saveChanges()">
        {{ 'SMS_REGISTRATION.FORM.ACTIONS.SAVE' | translate }}
      </button>
    } @else {
      <button mat-stroked-button (click)="saveChanges()">
        {{ 'SMS_REGISTRATION.FORM.ACTIONS.SAVE' | translate }}
      </button>
    }
    @if (isLastStep()) {
      <button
        mat-flat-button
        color="primary"
        (click)="submitRegistrationForm()"
        [disabled]="isA2pSubmitRestricted() || smsForm.invalid"
      >
        {{
          (isCampaignErrorState()
            ? 'SMS_REGISTRATION.FORM.ACTIONS.RESUBMIT_REGISTRATION'
            : 'SMS_REGISTRATION.FORM.ACTIONS.SUBMIT_REGISTRATION'
          ) | translate
        }}
      </button>
    } @else {
      <button mat-flat-button color="primary" (click)="nextStep()">
        {{ 'SMS_REGISTRATION.FORM.ACTIONS.NEXT' | translate }}
      </button>
    }
    @if (isA2pSubmitRestricted()) {
      <glxy-alert type="warning" size="small" [border]="false">
        {{ 'SMS_REGISTRATION.FORM.TRIAL_RESTRICTION_MESSAGE' | translate }}
      </glxy-alert>
    }
  </glxy-sticky-footer>
}
